<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .contact-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(12px);

    .contact-info {
      align-items: center;
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(8px);

      .contact-name {
        @include colors.color(textWhite);
        @include mixins.h3;
        cursor: pointer;
        transition: color 0.2s ease;
        background: none;
        border: none;
        padding: 0;
        margin: 0;

        &:hover {
          @include colors.color(primary_50);
        }

        &:empty {
          display: none;
        }
      }

      .phone-number {
        @include colors.color(textWhite);
        @include mixins.body1-bold;

        &.with-candidate {
          @include mixins.body3-bold;
        }
      }

      .job-title {
        @include colors.color(interfaceTransparentWhite_70);
        @include mixins.caption;
      }

      .keypad-digits {
        @include colors.color(textWhite);
        @include mixins.caption;
      }
    }
  }
</style>

<script>
  import DiallerAvatar from "./DiallerAvatar.svelte";
  import Tooltip from "../../../../../../svelte-design-system/components/atoms/Tooltip.svelte";
  import { getPhone } from "../utils/phoneUtils.js";

  let { attendee } = $props();

  let firstName = $derived(
    attendee?.firstName || attendee?.name?.split(" ")[0] || ""
  );
  let lastName = $derived(
    attendee?.lastName || attendee?.name?.split(" ").slice(1).join(" ") || ""
  );
  let phone = $derived(getPhone(attendee));

  let candidateExists = $derived(!!attendee?.candidateId);

  const handleNameClick = () => {
    if (candidateExists) {
      chrome.tabs.create({
        url: `https://sourcewhale.app/contacts?candidateId=${attendee?.candidateId}`,
      });
    }
  };
</script>

<div class="contact-container">
  <DiallerAvatar
    src={attendee?.photo}
    {firstName}
    {lastName}
    size="large"
    state="candidate"
    alt={attendee?.name || "Contact"}
    initialsVisible={candidateExists}
  />
  <div class="contact-info">
    {#if attendee?.name && candidateExists}
      <Tooltip
        placement="top"
        let:onmouseenter
        let:onmouseleave
        let:onfocus
        let:onblur
      >
        <span slot="tooltip">View in SourceWhale</span>
        <button
          class="contact-name"
          {onmouseenter}
          {onmouseleave}
          {onfocus}
          {onblur}
          onclick={handleNameClick}
        >
          {attendee.name}
        </button>
      </Tooltip>
    {/if}
    <div class="phone-number" class:with-candidate={candidateExists}>
      {phone}
    </div>
    {#if candidateExists && (attendee?.jobTitle || attendee?.company)}
      <div class="job-title">
        {#if attendee?.jobTitle && attendee?.company}
          {attendee.jobTitle} @ {attendee.company}
        {:else if attendee?.jobTitle}
          {attendee.jobTitle}
        {:else if attendee?.company}
          {attendee.company}
        {/if}
      </div>
    {/if}
  </div>
</div>
